import { render, staticRenderFns } from "./ClientsDiscountsChart.vue?vue&type=template&id=14d7179d&scoped=true"
import script from "./ClientsDiscountsChart.vue?vue&type=script&lang=js"
export * from "./ClientsDiscountsChart.vue?vue&type=script&lang=js"
import style0 from "./ClientsDiscountsChart.vue?vue&type=style&index=0&id=14d7179d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d7179d",
  null
  
)

export default component.exports